import styled from "styled-components";

export const SearchIntailSection = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.COLORS.textw};
`;

export const ResetButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.theme === 'dark' ? '#999' : '#666'};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'
    };
    color: #f44336;
  }
`;

export const HistoryItem = styled.div`
  padding: 10px 12px;
  background: ${({ theme }) =>
    theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'
  };
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;

  &:hover {
    background: ${({ theme }) =>
      theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)'
    };
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
